import { Box } from "@mui/material";
import { InvoiceItem } from "../invoiceTypes";

type Props = {
  invoiceNumber: string;
  invoiceDate: string;
  fromName: string;
  fromAddress: string;
  toName: string;
  toAddress: string;
  items: InvoiceItem[];
  currency: string;
  subtotal: number;
};

export const Invoice = ({
  invoiceNumber,
  invoiceDate,
  fromName,
  fromAddress,
  toName,
  toAddress,
  items,
  currency,
  subtotal,
}: Props) => {
  return (
    <Box sx={{ display: "none" }}>
      <div className="document-title">INVOICE</div>

      <div className="invoice-meta">
        <div className="meta-item">
          <div className="meta-label">Invoice Number</div>
          <div className="meta-value">{invoiceNumber}</div>
        </div>
        <div className="meta-item">
          <div className="meta-label">Invoice Date</div>
          <div className="meta-value">{invoiceDate}</div>
        </div>
      </div>

      <div className="parties-section">
        <div className="party-box">
          <div className="party-header">Seller Information</div>
          <div className="party-name">{fromName}</div>
          <div className="party-address">{fromAddress}</div>
        </div>

        <div className="party-box">
          <div className="party-header">Bill To</div>
          <div className="party-name">{toName}</div>
          <div className="party-address">{toAddress}</div>
        </div>
      </div>

      <div className="items-section">
        <div className="items-title">Items and Services</div>
        <table>
          <thead>
            <tr>
              <th style={{ width: "50%" }}>Description</th>
              <th className="text-center" style={{ width: "15%" }}>
                Quantity
              </th>
              <th className="text-right" style={{ width: "17.5%" }}>
                Unit Price ({currency})
              </th>
              <th className="text-right" style={{ width: "17.5%" }}>
                Amount ({currency})
              </th>
            </tr>
          </thead>
          <tbody>
            {items.map((it) => {
              const lineTotal =
                Number(it.quantity || 0) * Number(it.unitPrice || 0);
              return (
                <tr key={it.id}>
                  <td>{it.description}</td>
                  <td className="text-center">{it.quantity}</td>
                  <td className="text-right">{it.unitPrice.toFixed(2)}</td>
                  <td className="text-right">{lineTotal.toFixed(2)}</td>
                </tr>
              );
            })}
            <tr className="subtotal-row">
              <td colSpan={3} className="text-right">
                <strong>SUBTOTAL:</strong>
              </td>
              <td className="text-right">{subtotal.toFixed(2)}</td>
            </tr>
            <tr className="total-row">
              <td colSpan={3} className="text-right">
                <strong>TOTAL AMOUNT DUE ({currency}):</strong>
              </td>
              <td className="text-right">
                <strong>{subtotal.toFixed(2)}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="footer-notes">
        <p>
          <strong>Payment Terms:</strong> Payment due upon receipt.
        </p>
        <p>
          <strong>Note:</strong> Please make checks payable to {fromName}.
        </p>
        <p>Thank you for your business.</p>
      </div>

      <div className="signature-section">
        <div className="signature-box">
          <div className="signature-line">Authorized Signature</div>
        </div>
        <div className="signature-box">
          <div className="signature-line">Date</div>
        </div>
      </div>
    </Box>
  );
};
